import operations from 'rlink-collections/operations';
import _referencesAndReferenceValues from 'rlink-data-connector/storage/_referencesAndReferenceValues';
import {values} from 'rlink-data-connector/storage/collections';
import CACHES_SHAPE from 'rlink-data-connector/storage/CACHES_SHAPE';

export default function _replaceEmbeddedValuesWithReferencesAndUpdateTheirDependenceis (embeddedValue, referencesAndValues, caches) {
  let updateOps = [];
  Object.assign(referencesAndValues, _referencesAndReferenceValues(embeddedValue,
    {
      onBeginProcessing (rootEmbed) {
        // we are only updated by the objects we contain,
        // but we are about to re-discover what those are,
        // so start by removing ourselves from the updates
        // list of all objects we're updatedBy
        let rootRef = rootEmbed.reference;
        for (let referenceUpdatingUs of values(CACHES_SHAPE.getAt(caches, rootRef.storagePath('updatedBy')))) {
          updateOps.push([
            referenceUpdatingUs.storagePath('updates', rootRef.toString()),
            operations.rem,
            undefined,
          ]);
        }
        updateOps.push([
          rootRef.storagePath('updatedBy'),
          operations.set,
          {},
        ]);
      },
      onInnerEmbeddedValue (parentEmbedded, dependentEmbedded) {
        updateOps.push([
          dependentEmbedded.reference.storagePath('updates',
            parentEmbedded.reference.toString()),
          operations.set,
          parentEmbedded.reference,
        ]);
        updateOps.push([
          parentEmbedded.reference.storagePath('updatedBy', dependentEmbedded.reference.toString()),
          operations.set,
          dependentEmbedded.reference,
        ]);
      },
    }
  ));

  return updateOps;
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/_replaceEmbeddedValuesWithReferencesAndUpdateTheirDependenceis.js